import { useEffect } from 'react';

import AppBar from "@mui/material/AppBar";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import Typography from "@mui/material/Typography";

import ListViewRecipes from '../components/listViewRecipes';
import useCheckHistory from '../hooks/useCheckHistory';
import useFilterRecipe from '../hooks/useFilterRecipe';
import useLogRecipeEdit from '../hooks/useLogRecipeEdit';
import { EventLogsEnum } from '../utils/events';
import { BackIcon } from "../utils/iconRefs/recipeStepsIcons";
import styles from "./specificCategoryPage.module.css";

const FilteredRecipe = () => {
  const { recipes, heading, loading, filters } = useFilterRecipe();
  const { logRecipeEdit } = useLogRecipeEdit();
  const goBackOrRedirect = useCheckHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const onBack = () => {
    goBackOrRedirect('/');
    logRecipeEdit(EventLogsEnum.APP_BACK_PRESSED);
  };

  return (
    <Grid id="list-view-container">
      <AppBar className={styles.nav} id="navbar">
        <Grid className={styles.arrow} id="back-icon" onClick={onBack}>
          <BackIcon />
        </Grid>
        {loading ? (
          <Skeleton height="30px" id="header-skeleton" variant="text"
            width="150px" />
        ) : (
          <Grid id="category-header">
            <Typography className={styles.header_text} id="category-name" variant="body3">
              {heading}
            </Typography>
          </Grid>
        )}
        <Grid className={styles.filter_icon} id="filter-icon" />
      </AppBar>
      <ListViewRecipes
        filters={filters}
        loading={loading}
        recipes={recipes}
      />
    </Grid>
  );
};

export default FilteredRecipe;
